import { render } from "./Manifesto.vue?vue&type=template&id=1dee9816"
const script = {}
script.render = render

export default script